import Component from 'umg-ember-backend/components/record-detail/forms';
import ContentWithSidebar from 'umg-ember-backend/components/ui/content-with-sidebar';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsMlpVoucherComponent extends Component {
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <ContentWithSidebar>
        <:content>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field @property='campaign' />
            <fieldset.field @property='text' @type='text-editor' />
          </form.fieldset>
        </:content>
        <:sidebar>
          <form.fieldset @titleKey='assignments' as |fieldset|>
            <fieldset.field @property='product' @type='belongs-to' />
          </form.fieldset>
        </:sidebar>
      </ContentWithSidebar>
    </Form>
  </template>
}
